// All chat related types should be defined here
export var ChatType;
(function (ChatType) {
    ChatType["COMMUNITY_CHAT"] = "community-chat";
    ChatType["COMMUNITY_1_TO_1_CHAT"] = "community-1-to-1-chat";
})(ChatType || (ChatType = {}));
